import { createSlice, createAction } from '@reduxjs/toolkit';

import { fetchUserVehicles } from '../actions/userVehicles-actions';

export const setCurrentPage = createAction('carHouseVehicles/setCurrentPage');
export const setSearchParams = createAction('vehicle/setSearchParams');
export const setSortBy = createAction('vehicle/setSortBy');

const initialState = {
  isLoading: false,
  userVehicles: [],
  count: 0,
  currentPage: 1,
  perPage: 1,
};

const userVehiclesSlice = createSlice({
  name: 'userVehicles',
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchUserVehicles.pending, (state) => {
        state.isLoadingVehicles = true;
      })
      .addCase(fetchUserVehicles.fulfilled, (state, action) => {
        const { vehicles, count, page } = action.payload;
        state.isLoadingVehicles = false;
        state.userVehicles = vehicles;
        state.count = count;
      })
      .addCase(fetchUserVehicles.rejected, (state) => {
        state.isLoadingVehicles = false;
      })
      .addCase(setCurrentPage, (state, action) => {
        state.currentPage = action.payload;
      })
      .addCase(setSearchParams, (state, action) => {
        state.searchParams = action.payload; // Update the search parameters
      })
      .addCase(setSortBy, (state, action) => {
        state.sortBy = action.payload;
      });
  },
});

export const userVehiclesActions = {
  ...userVehiclesSlice.actions,
  setCurrentPage,
  setSearchParams,
  setSortBy,
};

export default userVehiclesSlice;
